import { BuildingService } from 'src/app/shared/services/rest/building.service';
import { MessageService } from 'src/app/shared/services/message.service';
import { TranslateService } from '@ngx-translate/core';

export abstract class BaseInfoComponent {

    protected building: BuildingService;

    protected messages: MessageService;

    protected translation: TranslateService;

    /**
     * Room info to display
     *
     * @type {IRoomInfo}
     * @memberof RoomInfoComponent
     */
    data: IRessourceInfo;

    /**
     * link to google maps
     *
     * @type {string}
     * @memberof RoomInfoComponent
     */
    mapLink: string;

    hasNoPermission: boolean;

    /**
     * Toggles the displaying the loading screen
     *
     * @memberof RoomInfoComponent
     */
    isLoading = true;

    constructor(
        building: BuildingService,
        messages: MessageService,
        translation: TranslateService
    ) {
        this.building = building;
        this.messages = messages;
        this.translation = translation;
    }

    abstract get id(): number;

    abstract get typePrefix(): string;

    /**
     * Load data from REST-Api
     *
     * @abstract
     * @memberof BaseInfoComponent
     */
    protected abstract onLoadData(): void;

    /**
     * Load data from REST-Api
     *
     * @private
     * @memberof RoomInfoComponent
     */
    protected loadData() {
        this.isLoading = true;
        this.hasNoPermission = false;

        this.onLoadData();
    }

    /**
     * Initialize link to Google Maps
     *
     * @param {string} street
     * @param {string} zip
     * @param {string} location
     * @param {string} [country='CH']
     * @memberof RoomInfoComponent
     */
    initMapLink(street: string, zip: string, location: string, country: string = 'CH') {
        if (street && zip && location) {
            const data = [street, zip + ' ' + location, country];
            this.mapLink = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(data.join(', '));
        }
    }

    /**
     * Handle click on open map link
     *
     * @memberof RoomInfoComponent
     */
    onClickMapLink() {
        const win = window.open(this.mapLink, '_blank');
        win.focus();
    }

}

export interface IRessourceInfo {

    Ressource: {
        Text: string,
        NumberPersons: number
    };

    Infrastructure: string;

    Remark: string;

    RessourceUrl: string;

    Site: string;

    Building: {
        Designation: string,
        Url: string,
        Floor: string
    };

    Address: string;
}
